'use client';

import { useEffect } from 'react';
import { logger } from '@axon/ui/utils';

export function ServiceWorkerRegistration() {
  useEffect(() => {
    if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
      const registerServiceWorker = async () => {
        try {
          const registration = await navigator.serviceWorker.register('/sw.js', {
            scope: '/',
          });

          // Force check for SW update on page load (prevents stale cache after deploy)
          // UpdatePrompt component handles the user-facing update flow
          registration.update().catch(() => {
            logger.warn('Service Worker update check failed');
          });

          registration.addEventListener('updatefound', () => {
            const installingWorker = registration.installing;
            if (!installingWorker) return;

            installingWorker.addEventListener('statechange', () => {
              if (installingWorker.state === 'installed') {
                if (navigator.serviceWorker.controller) {
                  logger.info('Service Worker updated, new content available');
                } else {
                  logger.info('Service Worker installed for the first time');
                }
              }
            });
          });
        } catch (error) {
          logger.error('Service Worker registration failed:', error);
        }
      };

      // Only register in production (PWA with serwist configured)
      if (process.env.NODE_ENV === 'production') {
        registerServiceWorker();
      } else {
        // Unregister stale service workers in development
        navigator.serviceWorker.getRegistrations().then((registrations) => {
          registrations.forEach((reg) => reg.unregister());
        });
      }
    }
  }, []);

  return null;
}
